import { exposes } from '@/mocks/exposes';
import type { ExposeItem } from '@/types/content';

export function getAllExposes(): ExposeItem[] {
  return exposes as unknown as ExposeItem[];
}

export function getExposeById(id: string): ExposeItem | undefined {
  return getAllExposes().find((item) => item.id === id);
}

export function getHotExposes(limit = 5): ExposeItem[] {
  return [...getAllExposes()].sort((a, b) => b.heat - a.heat).slice(0, limit);
}

export function getLatestExposes(limit = 6): ExposeItem[] {
  return [...getAllExposes()]
    .sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1))
    .slice(0, limit);
}

export function getRelatedExposes(item: ExposeItem, limit = 3): ExposeItem[] {
  const all = getAllExposes();
  const byId = item.relatedIds
    .map((id) => all.find((x) => x.id === id))
    .filter((x): x is ExposeItem => Boolean(x));
  if (byId.length >= limit) return byId.slice(0, limit);
  const fallback = all.filter((x) => x.id !== item.id && !item.relatedIds.includes(x.id));
  return [...byId, ...fallback].slice(0, limit);
}

export function formatHeat(heat: number): string {
  if (heat >= 10000) return `${(heat / 10000).toFixed(1)} 万`;
  return `${heat}`;
}